import React from 'react'
import LeftPage from './Pages/LeftPage/LeftPage'
import RightPage from './Pages/RightPage/RightPage'


const App = () => {
  return (
    <div className='flex'>
      
      <LeftPage/>
      
      
      <RightPage />
      
    </div>
  )
}

export default App

